<template>
    <div class='events-section'>
        <div class="details box is-radiusless is-marginless is-shadowless">
            <h4 class="is-size-5">Projektdetaljer</h4>
            <br>

            <ul>
                <li>Navn: {{project.name}}</li>

                <li>Færdighed: {{$t(`skills.${project.skill.name}.name`)}}</li>

                <li>Status: <strong>{{$t(`projects.status.${project.status}`)}}</strong></li>
            </ul>

            <br>

            <template v-if="project.cancelled_at">
                <p class="has-text-danger">Projektet er blev annulleret <strong>d. {{project.cancelled_at | formatShortDateTime}}</strong></p>
            </template>

            <template v-else-if="project.finalized_at">
                <p>Projektet blev afsluttet d. {{project.finalized_at | formatShortDateTime}}</p>
                <br>

                <template v-if="project.price_type !== 'unit'">
                    <p>Den studerende har brugt <strong>{{project.hours_used}} {{project.hours_used === 1 ? 'time' : 'timer'}}</strong> på opgaven.</p>
                    <br>
                    <p>Den endelige pris blev derfor på: <strong>{{project.hours_used * project.accepted_price}} kr. eks. moms</strong> ({{project.hours_used}} {{project.hours_used === 1 ? 'time' : 'timer'}} á {{project.accepted_price}} kr.).</p>
                </template>

                <p v-else>Den endelige pris blev: <strong>{{project.final_price}} kr. for hele opgaven eks. moms</strong></p>
            </template>

            <template v-else-if="project.accepted_price">
                <p>Prisen blev accepteret d. {{project.price_accepted_at | formatShortDateTime}}</p>
                <br>
                <p>Der er accepteret et tilbud på: <strong>{{project.offered_price}} kr. {{project.price_type === 'unit' ? 'for hele opgaven' : 'pr. time'}} eks. moms.</strong></p>

                <template v-if="project.price_type !== 'unit'">
                    <template v-if="project.hours_used">
                        <p>Den studerende anslår at der skal bruges <strong>{{project.hours_used}} {{project.hours_used === 1 ? 'time' : 'timer'}}</strong> på opgaven.</p>
                        <br>
                        <p>Prisen bliver derfor på: <strong>{{project.hours_used * project.offered_price}} kr. eks. moms</strong> ({{project.hours_used}} {{project.hours_used === 1 ? 'time' : 'timer'}} á {{project.offered_price}} kr.).</p>
                    </template>
                    <p v-else>Den studerende har ikke anslået et antal timer endnu.</p>
                </template>

            </template>

            <template v-else-if="project.offered_price">
                <p>Der er givet et tilbud på: <strong>{{project.offered_price}} kr. {{project.price_type === 'unit' ? 'for hele opgaven' : 'pr. time'}} eks. moms.</strong></p>
                <template v-if="project.price_type !== 'unit'">
                    <template v-if="project.hours_used">
                        <p>Den studerende anslår at der skal bruges <strong>{{project.hours_used}} {{project.hours_used === 1 ? 'time' : 'timer'}}</strong> på opgaven.</p>
                        <br>
                        <p>Tilbuddet bliver derfor på: <strong>{{project.hours_used * project.offered_price}} kr. eks. moms</strong> ({{project.hours_used}} {{project.hours_used === 1 ? 'time' : 'timer'}} á {{project.offered_price}} kr.).</p>
                    </template>

                    <p v-else>Den studerende har ikke anslået et antal timer endnu.</p>
                </template>

            </template>

            <template v-else>
                <p>Der er endnu ikke givet et tilbud</p>
            </template>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../../global/styles/variables';

</style>

<script>
    import Avatar from '@/taskflex/users/components/Avatar';

    export default {
        props: {
            project: {
                type: Object,
                required: true,
            },
        },

        mounted() {
            // join project-event-channel 'projects.ID.actions'
            // join project-event-channel 'projects.ID.events'
        },

        components: {
            Avatar,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/Projects/ProjectDetails.vue